import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';
import { Subscription } from 'rxjs';
import { SpinnerService } from 'src/app/components/shared-components/spinner/spinner.service';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { Router, ActivatedRoute } from '@angular/router';
import { SmsService } from 'src/app/services/sms-service/smsservice';

@Component({
  selector: 'app-sms-new-sms-creation-card',
  templateUrl: './sms-new-sms-creation-card.component.html',
  styleUrls: ['./sms-new-sms-creation-card.component.scss']
})
export class SmsNewSmsCreationCardComponent implements OnInit, OnDestroy {

  centerList;
  selectedCenters;
  showButton;
  addNewSmsSubscription: Subscription;
  basicDataForm = new FormGroup({
    active: new FormControl(true),
    smsName: new FormControl(null, Validators.required),
    smsSubject: new FormControl(null, Validators.required),
    smsPickAppointment: new FormControl(null),
    smsPickTurn: new FormControl(null),
    smsPickApointment: new FormControl(null),
    smsPreviousTurn: new FormControl(null),
    smsArrivalTurn: new FormControl(null),
  });

  constructor(private smsService: SmsService,
    private userStorageService: UserStorageService,
    private spinnerService: SpinnerService,
    private snackbarService: SnackBarService,
    private router: Router,
    private activatedRoute: ActivatedRoute) {
      this.showButton = true;
  }

  ngOnInit() {
    this.centerList = this.userStorageService.getCenterList();
  }

  public addNewSms() {
    this.showButton = false;
    this.spinnerService.show('sms-new-spinner');
    const validation = this.validateForm();
    if (validation === true) {
      this.addNewSmsSubscription = this.smsService.addNewSms(this.basicDataForm.get('smsName').value, this.filterCentersInternalId(this.selectedCenters), this.basicDataForm.get('active').value, this.basicDataForm.get('smsSubject').value, this.basicDataForm.get('smsPickAppointment').value, this.basicDataForm.get('smsPickTurn').value, this.basicDataForm.get('smsPreviousTurn').value, this.basicDataForm.get('smsArrivalTurn').value).subscribe(
        (res) => {
          this.showButton = true;
          this.spinnerService.hide('sms-new-spinner');
          this.router.navigate(['../smss'], { relativeTo: this.activatedRoute.parent });
        },
        (error) => {
          this.showButton = true;
          this.spinnerService.hide('sms-new-spinner');
          this.snackbarService.open(error['error']['message'], 'error');
        }
      );
    } else {
      this.showButton = true;
      this.spinnerService.hide('sms-new-spinner');
      this.snackbarService.open(validation, 'error');
    }
  }

  public validateForm() {
    if (!this.basicDataForm.get('smsName').valid) {
      return 'sms-page.snackbar messages.name sms error';
    } else if (!this.basicDataForm.get('smsSubject').valid) {
      return 'sms-page.snackbar messages.subject sms error';
    } else {
      return true;
    }
  }

  public centersDuallistboxOutputEventReceiver(selectedCenters) {
    const aux = new Array();
    for (const d of selectedCenters) {
      aux.push(d[1]._data);
    }
    if (aux) {
      this.selectedCenters = aux;
    }
  }

  public cancelSms() {
    this.router.navigate(['../smss'], { relativeTo: this.activatedRoute.parent });
  }

  private filterCentersInternalId(centers) {
    if (centers && (centers.length > 0)) {
      return centers.map(c => c.InternalId);
    } else {
      return [];
    }
  }

  ngOnDestroy() {
    if (this.addNewSmsSubscription) { this.addNewSmsSubscription.unsubscribe(); }
  }

}
